import {
  API_FAIL,
  API_SUCCESS,
  GET_CHARTS_DATA,
  GET_CHARTS_DATA_MESSAGE_STATUS,
  GET_CHARTS_DATA_MESSAGE_STATUS_FAIL,
  GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS,
  GET_LIST_BU_CHILD,
  GET_LIST_BU_CHILD_FAIL,
  GET_LIST_BU_CHILD_SUCCESS,
  GET_LIST_BU_STORE_HEADER,
  GET_LIST_BU_STORE_HEADER_FAIL,
  GET_LIST_BU_STORE_HEADER_SUCCESS,
  GET_LIST_BU_TENANT_HEADER,
  GET_LIST_BU_TENANT_HEADER_FAIL,
  GET_LIST_BU_TENANT_HEADER_SUCCESS,
  GET_LIST_TENANT_HEADER,
  GET_LIST_TENANT_HEADER_FAIL,
  GET_LIST_TENANT_HEADER_SUCCESS,
  RESET_GET_LIST_BU_CHILD,
  RESET_GET_LIST_BU_STORE_HEADER,
  RESET_GET_LIST_BU_TENANT_HEADER,
  RESET_SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_FAIL,
  SET_BU_STORE_HEADER_SCOPE,
  SET_BU_STORE_HEADER_SUCCESS,
  SET_BU_TENANT_HEADER,
  SET_BU_TENANT_HEADER_FAIL,
  SET_BU_TENANT_HEADER_SUCCESS,
  SET_TENANT_CODE_HEADER,
} from "./actionTypes";

const INIT_STATE = {
  chartsData: [],
  //
  listTenant: [],
  loadingListTenant: false,
  tenantCodeHeader: null,
  //
  listBuOfTenant: [],
  buTenantHeader: null,
  buTenantHeaderInfo: null,
  buSelect: null,
  //
  listBuStore: [],
  buStoreHeader: null,
  storeSelect: null,
  //
  finalBuInfo: null,
  finalBuReleaseInfo: null,
  finalListBuCode: [],
  //
  listMethodSign: [],
  listSignInfo: [],
  loadListMethodSign: false,
};

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CHARTS_DATA_MESSAGE_STATUS:
      return {
        ...state,
        loading: true,
        totalMessage: 0,
        listMessageWithStatus: {
          data: [],
        },
        chartsMLTDiep: {
          data: [],
        },
        chartMLTDiepInYear: {
          data: [],
        },
      };
    case GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        totalMessage: action.totalMessage,
        listMessageWithStatus: {
          data: action.listMessageWithStatus,
        },
        chartsMLTDiep: {
          data: action.chartsMLTDiep,
        },
        chartMLTDiepInYear: {
          data: action.chartMLTDiepInYear,
        },
      };
    case GET_CHARTS_DATA_MESSAGE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        totalMessage: 0,
        listMessageWithStatus: {
          data: [],
        },
        chartsMLTDiep: {
          data: [],
        },
        chartMLTDiepInYear: {
          data: [],
        },
        error: action.error,
      };
    case API_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CHARTS_DATA:
          return {
            ...state,
            chartsData: action.payload.data,
          };
        default:
          return state;
      }
    case API_FAIL:
      switch (action.payload.actionType) {
        case GET_CHARTS_DATA:
          return {
            ...state,
            chartsDataError: action.payload.error,
          };

        default:
          return state;
      }
    // GET_LIST_TENANT_HEADER
    case GET_LIST_TENANT_HEADER:
      return {
        ...state,
        loadingListTenant: true,
        listTenant: [],
      };
    case GET_LIST_TENANT_HEADER_SUCCESS:
      return {
        ...state,
        loadingListTenant: false,
        listTenant: action.listTenant,
      };
    case GET_LIST_TENANT_HEADER_FAIL:
      return {
        ...state,
        loadingListTenant: false,
        listTenant: [],
        error: action.error,
      };
    //SET_TENANT_CODE_HEADER
    case SET_TENANT_CODE_HEADER:
      return {
        ...state,
        tenantCodeHeader: action.tenantCodeHeader,
      };
    //SET_BU_TENANT_HEADER
    case SET_BU_TENANT_HEADER:
      return {
        ...state,
        buTenantHeader: action.buTenantHeader,
        buTenantHeaderInfo: action.buTenantHeaderInfo,
        // loadListMethodSign: true,
        listMethodSign: [],
        listSignInfo: [],
      };
    case SET_BU_TENANT_HEADER_SUCCESS:
      return {
        ...state,
        // loadListMethodSign: false,
        // listMethodSign: action.listMethodSign,
      };
    case SET_BU_TENANT_HEADER_FAIL:
      return {
        ...state,
        // loadListMethodSign: false,
        listMethodSign: [],
        listSignInfo: [],
      };
    // GET_LIST_BU_TENANT_HEADER
    case GET_LIST_BU_TENANT_HEADER:
      return {
        ...state,
        listBuOfTenant: [],
        listMethodSign: [],
        listSignInfo: [],
        type: action.type,
      };
    case GET_LIST_BU_TENANT_HEADER_SUCCESS:
      return {
        ...state,
        listBuOfTenant: action.listBu,
        type: action.type,
      };

    case GET_LIST_BU_TENANT_HEADER_FAIL:
      return {
        ...state,
        listBuOfTenant: [],
        type: action.type,
      };
    case RESET_GET_LIST_BU_TENANT_HEADER:
      return {
        ...state,
        type: action.type,
      };
    // GET_LIST_BU_CHILD
    case GET_LIST_BU_CHILD:
      return {
        ...state,
        listBuChild: [],
        type: action.type,
      };
    case GET_LIST_BU_CHILD_SUCCESS:
      return {
        ...state,
        listBuChild: action.listBuChild,
        type: action.type,
      };

    case GET_LIST_BU_CHILD_FAIL:
      return {
        ...state,
        listBuChild: [],
        type: action.type,
      };
    case RESET_GET_LIST_BU_CHILD:
      return {
        ...state,
        type: action.type,
      };
    // GET_LIST_BU_STORE_HEADER
    case GET_LIST_BU_STORE_HEADER:
      return {
        ...state,
        listBuStore: null,
        // listMethodSign: [],
        type: action.type,
      };
    case GET_LIST_BU_STORE_HEADER_SUCCESS:
      return {
        ...state,
        listBuStore: action.listBuStore,
        type: action.type,
      };
    case GET_LIST_BU_STORE_HEADER_FAIL:
      return {
        ...state,
        listBuStore: [],
        type: action.type,
      };
    case RESET_GET_LIST_BU_STORE_HEADER:
      return {
        ...state,
        type: action.type,
      };

    //SET_BU_STORE_HEADER
    case SET_BU_STORE_HEADER:
      return {
        ...state,
        buStoreHeader: action.buStoreHeader,
        buSelect: action.buSelect,
        storeSelect: action.storeSelect,
        loadListMethodSign: true,
        listMethodSign: [],
        listSignInfo: [],
        finalBuInfo: null,
        finalBuReleaseInfo: null,
        type: action.type,
      };
    // Phạm vi chi nhánh/đơn vị: về trước, các trang load danh sách được ngay
    case SET_BU_STORE_HEADER_SCOPE:
      console.log("Phạm vi chi nhánh/đơn vị hiện tại ", {
        finalBuInfo: action.finalBuInfo,
        finalBuReleaseInfo: action.finalBuReleaseInfo,
        buStoreHeader: action.bu_store_header,
        finalListBuCode: action.finalListBuCode,
      });
      return {
        ...state,
        buStoreHeader: action.bu_store_header,
        finalBuInfo: action.finalBuInfo,
        finalBuReleaseInfo: action.finalBuReleaseInfo,
        finalListBuCode: action.finalListBuCode,
        type: action.type,
      };
    // Cấu hình chữ ký: về sau, chỉ ảnh hưởng các modal ký
    case SET_BU_STORE_HEADER_SUCCESS:
      console.log("Cấu hình chữ ký của đơn vị hiện tại ", {
        listMethodSign: action.listMethodSign,
        listSignInfo: action.listSignInfo,
      });
      return {
        ...state,
        loadListMethodSign: false,
        listMethodSign: action.listMethodSign,
        listSignInfo: action.listSignInfo,
        type: action.type,
      };
    case SET_BU_STORE_HEADER_FAIL:
      // Chỉ xoá dữ liệu cấu hình chữ ký. Không đụng tới buSelect/storeSelect và
      // phạm vi (finalBuInfo/finalListBuCode) vì chúng lấy từ lựa chọn của user,
      // không phụ thuộc 2 api này - lỗi cấu hình không được làm trống header
      // hay làm hỏng danh sách đang hiển thị
      return {
        ...state,
        loadListMethodSign: false,
        listMethodSign: [],
        listSignInfo: [],
      };
    case RESET_SET_BU_STORE_HEADER:
      return {
        ...state,
        type: action.type,
      };
    default:
      return state;
  }
};

export default Dashboard;
